import React, { useState, useEffect, useRef } from "react";
import styled from "styled-components";
import ScreenReader from "components/ScreenReader";
import Button from "components/Button";
import CloseIcon from "./close-icon.svg";

const Container = styled.div`
  position: absolute;
  z-index: 10;
  top: 1rem;
  right: 1rem;
`;

const Toggle = styled.button`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 5rem;
  height: 5rem;

  svg {
    display: block;
    width: 2.2rem;
    height: auto;
  }

  @media (min-width: 640px) {
    svg {
      width: 3rem;
    }
  }
`;

const PopOver = styled.div`
  position: absolute;
  z-index: 10;
  top: 100%;
  right: 0;
  display: block;
  margin-top: 1rem;
  width: 20rem;
  border-radius: 4px;
  box-shadow: 0 6px 18px 0 rgba(#000, 0.3);
  background-color: #fff;
  border: 1px solid #e7e7e7;
  padding: 1.5rem 1.5rem 0.5rem;
  opacity: ${props => (props.open ? 1 : 0)};
  visibility: ${props => (props.open ? "visible" : "hidden")};
  transition: opacity 0.15s ease-out, visibility 0.15s ease-out;

  &::after,
  &::before {
    bottom: 100%;
    right: 1.2rem;
    border: solid transparent;
    content: " ";
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
  }

  &::after {
    right: 1.3rem;
    border-color: rgba(255, 255, 255, 0);
    border-bottom-color: #fff;
    border-width: 10px;
    margin-left: -10px;
  }
  &::before {
    border-color: rgba(231, 231, 231, 0);
    border-bottom-color: #e7e7e7;
    border-width: 11px;
    margin-left: -11px;
  }
`;

const buttonStyles = {
  padding: "1.5rem",
  width: "100%",
  minWidth: "0",
  marginBottom: "1rem"
};

const ActionMenu = props => {
  const ref = useRef(null);

  const [open, setOpen] = useState(false);

  const handleToggle = () => setOpen(prevOpen => !prevOpen);

  const handleClick = e => {
    if (ref.current && ref.current.contains(e.target)) return;
    setOpen(false);
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClick, false);

    return () => {
      document.removeEventListener("mousedown", handleClick, false);
    };
  }, []);

  const handleReset = () => {
    props.dispatch({ type: "RESET_QUIZ" });
    setOpen(false);
  };

  return (
    <Container ref={ref}>
      <Toggle type="button" onClick={handleToggle}>
        <ScreenReader>Quiz Actions</ScreenReader>
        <CloseIcon />
      </Toggle>

      <PopOver open={open}>
        <Button type="button" onClick={handleReset} style={buttonStyles}>
          Reset Quiz
        </Button>
        <Button
          href="/quiz/[slug]"
          as={`/quiz/${props.slug}`}
          style={buttonStyles}
        >
          Exit Quiz
        </Button>
      </PopOver>
    </Container>
  );
};

export default ActionMenu;
